/* eslint-disable camelcase */
module.exports = function (self) {
	return {
		async topClicks({ start_date = null, end_date = null, keywords = null }) {
			try {
				const response = await self.$http.get(
					'topClicks', {
						params: {
							start_date,
							end_date,
							keywords,
						},
						headers: {
							Authorization: true,
							baseType: 'tracking',
						},
					},
				);

				return {
					ok: true,
					data: response.data.results,
				};
			} catch (error) {
				return {
					ok: false,
					data: [],
				};
			}
		},
		async get() {
			try {
				const response = await self.$http.get(
					'trackings', {
						params: {},
						headers: {
							Authorization: true,
							baseType: 'tracking',
						},
					},
				);

				return {
					ok: true,
					data: response.data.trackings,
				};
			} catch (error) {
				return {
					ok: false,
					data: [],
				};
			}
		},
		async edit(trackings) {
			try {
				await self.$http.put(
					'trackings', {
						trackings,
					}, {
						headers: {
							Authorization: true,
							baseType: 'tracking',
						},
					},
				);

				self.resetStatus();

				return true;
			} catch (error) {
				self.resetStatus();
				return false;
			}
		},
		async delete(trackings) {
			try {
				const result = await self.$http.delete(
					'trackings', {
						headers: {
							Authorization: true,
							baseType: 'tracking',
						},
						data: {
							trackings,
						},
					},
				);

				self.resetStatus();

				if (result) return true;
				return false;
			} catch (error) {
				self.resetStatus();
				return false;
			}
		},
	};
};
